<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
  @if (isActivation) {
    <div class="form-group">
      <p class="text-center">Now choose your password you’ll be using to log in, and you’re all set. (You can always change your password later.)</p>
    </div>
  }

  @if (!token) {
    <div class="form-group">
      <label for="current-password">Your current password</label>
      <input
        type="password"
        name="current-password"
        class="form-control"
        formControlName="currentPassword"
        autocomplete="current-password"
        [ngClass]="{ 'is-invalid': f.currentPassword.invalid && f.currentPassword.dirty }"
      />
      @if (isFieldInvalid('currentPassword')) {
        <mat-error>
          @if (f.currentPassword.errors?.wrongPassword) {
            <span>Incorrect password</span>
          }
        </mat-error>
      }
    </div>
  }

  <shared-password-definition
    [formControl]="f.password"
    [passwordLabel]="'Choose your password'"
    [passwordConfirmationLabel]="'Enter your password again'"
  />

  @if (isActivation && f.agreeTermsOfUse) {
    <div class="form-group">
      <mat-checkbox formControlName="agreeTermsOfUse">I agree to the <a href="https://www.pointee.com/terms" target="_blank">Terms of use</a></mat-checkbox>
    </div>
  }

  <button type="submit" [disabled]="form.invalid" class="btn btn-primary btn-block">
    @if (isActivation) {
      <span>Activate my account</span>
    } @else {
      <span>Set a new password</span>
    }
  </button>
</form>
